var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4604",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path4598",
    d: "M12 23c6.1 0 11-4.9 11-11S18.1 1 12 1 1 5.9 1 12s4.9 11 11 11z",
    fill: "#d50b40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4600",
    className: "st1",
    d: "M12 14.8c.6 0 1.1-.5 1.1-1.1V6.9c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v6.8c0 .6.5 1.1 1.1 1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path4602",
    className: "st1",
    d: "M12 18.2c.6 0 1.1-.5 1.1-1.1v-.2c0-.6-.5-1.1-1.1-1.1s-1.1.5-1.1 1.1v.2c0 .6.5 1.1 1.1 1.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputAlert);
export default __webpack_public_path__ + "static/media/input-alert.21427b638687d21457c1dfcc2653dca8.svg";
export { ForwardRef as ReactComponent };